import { render } from "./payment_people.vue?vue&type=template&id=a5d1368a&scoped=true"
import script from "./payment_people.vue?vue&type=script&lang=js"
export * from "./payment_people.vue?vue&type=script&lang=js"

import "./payment_people.vue?vue&type=style&index=0&id=a5d1368a&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d1368a"]])

export default __exports__